export const ROUTES = {
	TRANSACTIONS: 'transactions',
	DEALS_PRIVILEGES: 'deals-privileges',
	REDEMPTIONS: 'redemptions'
}

export const QUERY_PARAMS = {
	TAB: 'tab'
}
